import { render, staticRenderFns } from "./settle-setting.vue?vue&type=template&id=3e6ffad1&scoped=true&"
import script from "./settle-setting.vue?vue&type=script&lang=js&"
export * from "./settle-setting.vue?vue&type=script&lang=js&"
import style0 from "./settle-setting.vue?vue&type=style&index=0&id=3e6ffad1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e6ffad1",
  null
  
)

export default component.exports